import React from "react";

export const Venus = () => {
  return (
    <div>
      <div
        id={"venus"}
        style={{
          frameborder: "0",
          width: "100%",
          height: "470px",
        }}
      ></div>
    </div>
  );
};
